import React, { useState } from 'react';
import { SectionProps } from '../../types';
import { Button, Collapse, Tooltip } from 'antd';
import collect from 'collect.js';
import { CloseOutlined, SelectOutlined } from '@ant-design/icons';

type Props = SectionProps & {
  onStoreSelected: (id: string) => Promise<void>;
};

export default function FranchiseRestaurants({ data, onStoreSelected }: Props) {
  const [loadingStoreDetails, setLoadingStoreDetails] = useState(null);

  const _onStoreSelected = (id: string) => {
    setLoadingStoreDetails(id);
    onStoreSelected(id).finally(() => setLoadingStoreDetails(null));
  };

  return (
    data.franchise.stores.length > 1 && (
      <Collapse
        ghost
        className="mt-sm"
        expandIconPosition="end"
        items={[
          {
            key: '1',
            classNames: {
              header: '!p-none w-fit',
              body: '!p-none !pl-lg',
            },
            label: (
              <p className="text-sm">
                <span className="underline uppercase text-danger">Franchise</span>
                {' · '}
                <span className="cursor-pointer">See other locations</span>
              </p>
            ),
            children: (
              <ul className="list-disc">
                {collect(data.franchise.stores)
                  .where('id', '!=', data.id)
                  .map((item) => (
                    <li key={`store-${item.id}`} className="mt-xs text-sm">
                      {item.name}
                      {' - '}
                      {item.formatted_address}
                      <Tooltip
                        title={
                          item.occ_enabled
                            ? 'Switch'
                            : 'Call center is not supported for this location'
                        }
                        className="ml-xs"
                      >
                        <Button
                          shape="circle"
                          icon={item.occ_enabled ? <SelectOutlined /> : <CloseOutlined />}
                          loading={loadingStoreDetails === item.id}
                          onClick={() => (item.occ_enabled ? _onStoreSelected(item.id) : null)}
                        />
                      </Tooltip>
                    </li>
                  ))}
              </ul>
            ),
          },
        ]}
      />
    )
  );
}
